// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"WK-z","carouselContainer":"XK-z"};